import { render, staticRenderFns } from "./DefaultNavigationBar.vue?vue&type=template&id=085fd052&scoped=true"
import script from "./DefaultNavigationBar.vue?vue&type=script&lang=ts"
export * from "./DefaultNavigationBar.vue?vue&type=script&lang=ts"
import style0 from "./DefaultNavigationBar.vue?vue&type=style&index=0&id=085fd052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085fd052",
  null
  
)

export default component.exports